import { types } from "../../types/types";

const initialState = {
  loading: false,
  liquidadores: [],
  efectoresPorLiquidador: []
};

export const efectoresPorLiquidadorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.efectoresPorLiquidadorTraerStart:
      return {
        ...state,
        loading: true,
      };
    case types.efectoresPorLiquidadorTraerSuccess:
      return {
        ...state,
        liquidadores: action.payload,
        loading: false,
      };
    case types.efectoresPorLiquidadorPorUsuarioTraerSuccess:
      return {
        ...state,
        efectoresPorLiquidador: action.payload,
        loading: false,
      };
    case types.efectoresPorLiquidadorTraerError:
      return {
        ...state,
        loading: false,
      };
    case types.efectoresPorLiquidadorPorUsuarioTraerError:
      return {
        ...state,
        loading: false,
      };
    case types.efectoresPorLiquidadorInsert:
      return {
        ...state,
        liquidadores: [
          ...state.liquidadores,
          action.payload,
        ],
        loading: false,
      };
    case types.efectoresPorLiquidadorDelete:
      return {
        ...state,
        liquidadores: state.liquidadores.filter(
          (item) => item.idLiquidador !== action.payload
        ),
        loading: false,
      };
    default:
      return state;
  }
};
